import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import tokens from '../theme/tokens';

// 소셜 로그인 버튼 — 네이버(초록) · 카카오(노랑) · 구글(흰색). 아직 열지 않은 제공자는 disabled + 오른쪽 '준비중' 표시
export const PROVIDERS = {
  naver: { label: '네이버로 시작하기', bg: '#03c75a', fg: '#ffffff', border: '#03c75a' },
  kakao: { label: '카카오로 시작하기', bg: '#fee500', fg: '#191919', border: '#fee500' },
  google: { label: '구글로 시작하기', bg: '#ffffff', fg: tokens.ink, border: tokens.line },
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 52,
    borderRadius: 12,
    border: '1px solid transparent',
    fontSize: 15,
    fontWeight: 700,
    letterSpacing: -0.6,
    transition: 'filter .12s, transform .12s',
    '&:hover': { filter: 'brightness(0.97)' },
    '& + &': { marginTop: 10 },
  },
  disabled: {
    opacity: 0.55,
    cursor: 'default',
    '&:hover': { filter: 'none' },
  },
  mark: {
    position: 'absolute',
    left: 18,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 22,
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  note: {
    position: 'absolute',
    right: 14,
    top: '50%',
    transform: 'translateY(-50%)',
    height: 24,
    padding: '0 9px',
    borderRadius: 12,
    backgroundColor: 'rgba(22, 22, 23, 0.08)',
    fontSize: 12,
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: -0.4,
  },
}));

// 제공자 마크 — 외부 아이콘 폰트 대신 인라인 SVG
function Mark({ provider }) {
  if (provider === 'naver') {
    return (
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path fill="#ffffff" d="M14.6 4v8.3L9.4 4H4v16h5.4v-8.3l5.2 8.3H20V4z" />
      </svg>
    );
  }
  if (provider === 'kakao') {
    return (
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path fill="#191919" d="M12 3C6.5 3 2 6.5 2 10.8c0 2.8 1.9 5.2 4.7 6.6l-1 3.7c-.1.3.3.6.6.4l4.4-2.9c.4 0 .9.1 1.3.1 5.5 0 10-3.5 10-7.9S17.5 3 12 3z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path fill="#4285F4" d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.7 3-4.3 3-7.3z" />
      <path fill="#34A853" d="M12 22c2.7 0 5-.9 6.6-2.4l-3.2-2.5c-.9.6-2 1-3.4 1-2.6 0-4.8-1.8-5.6-4.1H3.1v2.6A10 10 0 0 0 12 22z" />
      <path fill="#FBBC05" d="M6.4 14a6 6 0 0 1 0-3.8V7.6H3.1a10 10 0 0 0 0 9z" />
      <path fill="#EA4335" d="M12 6c1.5 0 2.8.5 3.8 1.5l2.9-2.9A10 10 0 0 0 3.1 7.6l3.3 2.6C7.2 7.8 9.4 6 12 6z" />
    </svg>
  );
}

function SocialButton({ provider, onClick, disabled = false, note = '', id }) {
  const cs = useStyles();
  const p = PROVIDERS[provider];
  return (
    <ButtonBase
      id={id}
      className={clsx(cs.root, disabled && cs.disabled)}
      style={{ backgroundColor: p.bg, color: p.fg, borderColor: p.border }}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      focusRipple={false}
      aria-disabled={disabled}
    >
      <span className={cs.mark}><Mark provider={provider} /></span>
      {p.label}
      {disabled && note && <span className={cs.note}>{note}</span>}
    </ButtonBase>
  );
}

export default SocialButton;
